import { HelprerContentItem } from "../../../../types/propsTypes";

export const trainingProgramsHelpers = {
    pageTitle: [
        {
            type: 'title',
            text: 'Программа обучения'
        },
        'Отобажается на странице курса. Данный объект поддерживает сортировку (порядок расположения)',
        {
            type: 'image',
            imgSrc: '/static/img/helper/page-title/training-program.jpg',
        }
    ] as HelprerContentItem[]
}